import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListShippedAtCell } from './emsp-bo-rfid-badge-order-list-shipped-at.cell';
import { EmspBoRfidBadgeOrderListShippedAtHeader } from './emsp-bo-rfid-badge-order-list-shipped-at.header';

export const EmspBoRfidBadgeOrderListShippedAtColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['shippedAt']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListShippedAtHeader,
  cell: EmspBoRfidBadgeOrderListShippedAtCell,
};
